import React from 'react';
import { Separator } from 'react-resizable-panels';
import { useTheme } from "@mui/material";


const ResizeSeparator = ({ 
    orientation = 'vertical',    
    ...props    
}) => {
    const theme = useTheme();
    const isVertical = orientation === 'vertical';

    const {
        hidden = false,
        frameWidth = 8, 
        lineWidth = 1,
        gripVisible = true,
    } = props;

    if (hidden) return null;

    return (
        <Separator
            style={{
                position: 'relative',
                zIndex: 10,
                width: isVertical ? frameWidth : '100%',
                height: isVertical ? '100%' : frameWidth,
                background: 'transparent',
                cursor: isVertical ? 'col-resize' : 'row-resize',
                flexShrink: 0,
            }}
        >
            <div
                style={{
                    pointerEvents: 'none',
                    position: 'absolute',
                    left: isVertical ? '50%' : 0,
                    top: isVertical ? 0 : '50%',
                    width: isVertical ? lineWidth : '100%',
                    height: isVertical ? '100%' : lineWidth,
                    backgroundColor: theme.palette.neutral.main,
                    transform: isVertical ? 'translateX(-50%)' : 'translateY(-50%)',
                    transition: 'background-color 0.15s',
                }}
            />

            {gripVisible && (
                <div
                    style={{
                        pointerEvents: 'none',
                        zIndex: 9,
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        transform: 'translate(-50%, -50%)',
                        width: isVertical ? 8 : 48,
                        height: isVertical ? 48 : 8,
                        borderRadius: 20,
                        backgroundColor: theme.palette.neutral.darkest,
                        border: `1px solid ${theme.palette.neutral.light}`,
                        boxShadow:
                            '0 4px 6px -1px rgba(0,0,0,0.1), 0 2px 4px -1px rgba(0,0,0,0.06), inset 0 1px 1px rgba(255,255,255,1)',
                        display: 'flex',
                        flexDirection: isVertical ? 'column' : 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 4,
                    }}
                >
                    {[0, 1, 2].map(i => (
                        <div
                            key={i}
                            style={{
                                width: isVertical ? 4 : 2,
                                height: isVertical ? 2 : 4,
                                borderRadius: 1,
                                backgroundColor: theme.palette.neutral.light,
                            }}
                        />
                    ))}
                </div>
            )}
        </Separator>
    );
};

export default ResizeSeparator;
